/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Gang View: View user created gangs(teams of employees)
***********************************************************/
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HarvestList from '../harvest_list';
import { DatePicker2 } from '../../inputs';
import MechanicalHarvestEditForm from './mechHarvest_edit_form';
import MechHarvestModal from '../mechHarvest_modal';
import MechHarvestDeleteModal from './mechHarvest_delete_modal';
import { packageDashForm } from '../../../utils';
import { fetchFieldsByLoc, fetchBlocksByField } from '../../../actions';
import { selectField, prepareMechHarvest, fetchMyMechHarvest,
  selectHarvestToManage, resetManageHarvest, fetchHarvestByDate,
  updateMechHarvest, deleteMechHarvest } from '../../../actions/harvest_actions';

class MechanicalHarvestManage extends Component {
  constructor(props) {
    super(props);
    this.fetchHarvest = this.fetchHarvest.bind(this);
  }
  componentDidMount() {
    this.props.fetchMyMechHarvest(this.props.eid);
  }
  fetchHarvest() {
    let date = document.getElementById('mechHarvest-manage-date').value;
    if (date === '' || date === undefined || date === null) return;
    return this.props.fetchHarvestByDate(date);
  }
  render() {
    let max = moment().format('YYYY-MM-DD');
    //let min = moment().subtract(10, 'days').format('YYYY-MM-DD');
    return (
      <div className="row">
        <blockquote><span className="flow-text">Manage Mechanical Harvest</span></blockquote>
        <hr />
        <div className="col s12 m3 l3 xl3">
          <div className="harvest-list">
            <div className="card">
              <HarvestList harvest={this.props.myHarvest} onClick={this.props.selectHarvestToManage}
                id={'mechHarvest-manage-list'} />
            </div>
          </div>
          <form onSubmit={(e) => e.preventDefault()}>
            <DatePicker2 id={'mechHarvest-manage-date'} label={'Select a Date'} max={max} />
            <button className="btn waves-effect waves-light" onClick={this.fetchHarvest}>Fetch</button>
          </form>
        </div>
        <div className="col s12 m9 l9 xl9">
        { this.props.isEditOrDelete ?
          <div className="harvest-edit-or-delete">
            <button data-target="mechHarvest-edit-modal" className="btn blue"
              onClick={() => this.props.prepareMechHarvest(packageDashForm('mechHarvest-edit-form'), this.props.selectedField,
                this.props.seasons, this.props.employees, 'edit')}>
              Edit
            </button>
            <button data-target="mechHarvest-delete-modal" className="btn red">Delete</button>
            <button className="btn white clear-btn" onClick={this.props.resetManageHarvest}>Clear</button>
            <MechHarvestModal id={'mechHarvest-edit-modal'} selectedField={this.props.selectedField} harvest={this.props.editedHarvest}
              previousHarvest={this.props.previousHarvest} equipmentNo={this.props.equipmentNo} onClick={this.props.updateMechHarvest}
              selectedHarvest={this.props.selectedHarvest} />
            <MechHarvestDeleteModal id={'mechHarvest-delete-modal'} selectedField={this.props.selectedField} onClick={this.props.deleteMechHarvest}
              selectedHarvest={this.props.selectedHarvest} />
          </div>
          : '' }
          <MechanicalHarvestEditForm fetchFieldsByLoc={this.props.fetchFieldsByLoc} fetchBlocksByField={this.props.fetchBlocksByField}
            fields={this.props.fields} blocks={this.props.blocks} selectField={this.props.selectField} selectedField={this.props.selectedField}
            submitter={this.props.eid} equipmentNo={this.props.equipmentNo} employees={this.props.employees} id={this.props.selectedHarvest.id} />
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    blocks: state.harvest.blocks,
    eid: state.auth.user.eid,
    editedHarvest: state.harvest.manage.editedHarvest,
    employees: state.harvest.employees.displaying,
    equipmentNo: state.harvest.equipmentNo,
    fields: state.harvest.fields,
    isEditOrDelete: state.harvest.manage.isEditOrDelete,
    myHarvest: state.harvest.manage.myHarvest,
    previousHarvest: state.harvest.manage.previousHarvest,
    seasons: state.harvest.seasons,
    selectedField: state.harvest.manage.selectedField,
    selectedHarvest: state.harvest.manage.selectedHarvest,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    deleteMechHarvest,
    fetchFieldsByLoc,
    fetchBlocksByField,
    fetchHarvestByDate,
    fetchMyMechHarvest,
    prepareMechHarvest,
    resetManageHarvest,
    selectField,
    selectHarvestToManage,
    updateMechHarvest
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MechanicalHarvestManage);




/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/manage/mechHarvest_manage.jsx